import JovRegisterOnlineId from './JovRegisterOnlineIdContainer';

export default JovRegisterOnlineId;